import { GifOverlayProps } from '@giphy/react-components'
import React, { ReactType, SyntheticEvent, useContext, createContext } from 'react'
import GifSelectionOverlay from './gif-selector-overaly'
import GifMenuOverlay from './gif-menu-overlay'
import { IGif } from '@giphy/js-types'
import { useKeyPress } from 'react-use'

type GridOverlayContextProps = {
    onGifClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    selectedGifs: (number | string)[]
    iSelectionMode: boolean
    Overlay?: ReactType<GifOverlayProps>
}
export const GridOverlayContext = createContext({} as GridOverlayContextProps)

const GridOverlay = ({ gif, isHovered }: GifOverlayProps) => {
    const { onGifClick, selectedGifs, iSelectionMode, Overlay } = useContext(GridOverlayContext)
    const [isDetailMode] = useKeyPress((event: KeyboardEvent) => event.keyCode === 18)
    return iSelectionMode ? (
        <GifSelectionOverlay
            gif={gif}
            index={selectedGifs.indexOf(gif.id)}
            onClick={onGifClick}
            showDetails={isDetailMode}
        />
    ) : Overlay ? (
        <>
            <Overlay gif={gif} isHovered={isHovered} />
            <GifMenuOverlay gif={gif} isHovered={isHovered} />
        </>
    ) : (
        <GifMenuOverlay gif={gif} isHovered={isHovered} />
    )
}

export default GridOverlay
